import React from 'react'
import { Link } from 'react-router-dom'
import './notfound.css'

export default function NotFound() {
    return (
        <div className='not-found'>
            <div className='content'>
                <div className='_404'>404</div>
                <hr />
                <div className='_1'>THE PAGE</div>
                <div className='_2'>WAS NOT FOUND</div>
                <Link className='btn' to='/'>BACK TO MARS</Link>
            </div>
        </div >
    )
}
